import DataTypes from 'constants/DataTypes'
import MeasurementUnits from 'constants/MeasurementUnits'

export const DefaultMeasurementUnits = {
  [DataTypes.TEMPERATURE]: MeasurementUnits.CELSIUS,
  [DataTypes.VOCS_INDEX]: MeasurementUnits.VOCS_INDEX,
  [DataTypes.VOCS]: MeasurementUnits.VOCS_PPB,
  [DataTypes.FORMALDEHYDE]: MeasurementUnits.FORMALDEHYDE_UG,
  [DataTypes.CO]: MeasurementUnits.CO_PPM,
  [DataTypes.O3]: MeasurementUnits.O3_PPB,
  [DataTypes.NO2]: MeasurementUnits.NO2_PPB,
  [DataTypes.PM1]: MeasurementUnits.PM1_UG,
  [DataTypes.PM4]: MeasurementUnits.PM4_UG,
  [DataTypes.PM10]: MeasurementUnits.PM10_UG,
  [DataTypes.PM25]: MeasurementUnits.PM25_UG
}

export const getDefaultMeasurementUnit = dataType => {
  return DefaultMeasurementUnits[dataType]
}
export const getCompleteMeasurementUnits = (measurementUnits = {}) => ({
  ...DefaultMeasurementUnits,
  ...measurementUnits
})
